export const isMobileUserAgent = (userAgent: string): boolean => {
  if (!userAgent) {
    return false
  }

  const mobileRegex =
    /Android|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Opera Mini|Mobile|Mobi/i

  return mobileRegex.test(userAgent)
}

/**
 * iPad 여부를 감지합니다.
 *
 * iPadOS 13부터 Safari가 데스크탑 사이트를 기본으로 요청하면서
 * UA가 'Macintosh; Intel Mac OS X...' 형태로 변경되어 'iPad' 문자열이 사라졌습니다.
 * 이를 보완하기 위해 UA의 Macintosh 여부와 터치 지원 여부를 함께 확인합니다.
 */
export const isIPad = (): boolean => {
  if (typeof navigator === 'undefined') return false

  // iPadOS 12 이하, 또는 iPadOS 13+ Chrome 등 비Safari 브라우저
  if (/iPad/.test(navigator.userAgent)) return true

  // iPadOS 13+ Safari: UA가 macOS처럼 보이지만 터치를 지원함
  return /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1
}
